import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBreakfast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBreakfast"><Path d="M21.25 12.2009C21.25 17.4206 21.0652 21.9035 14.7009 20.2176C12.6858 19.6838 10.3296 21.3513 8.65565 21.2451C0.532132 20.7297 0.427422 2.7499 10.6055 2.75C16.3466 2.75005 14.7305 5.54196 16.3466 7.47546C17.7442 9.14751 21.25 7.47546 21.25 12.2009Z" stroke="currentColor" strokeWidth="1.5"/><Circle cx="11" cy="13" r="3.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconBreakfast;
